/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


angular
    .module('menuAllSites')
    .factory('getAllSites', getAllSites);
getAllSites.$inject = ['$http'];

angular
    .module('menuAllSites')
    .factory('getPluginDir', getAllSites);
getPluginDir.$inject = ['$http'];



function getAllSites($http) {
    var getAllSites = {
        async: function () {
            void 0;
            // $http returns a promise, which has a then function, which also returns a promise
            var promise = $http.post(sessionStorage.plugindir+"getAllSites.php", {}, {headers: {'Content-Type': 'application/json'}})
            .then(function (response) {
//                    console.log(response.data);
                return response.data;
            });
            // Return the promise to the controller
            return promise;
        }
    };
    return getAllSites;
}

function getPluginDir(){
    
}